import { DEFAULT_ADMIN_CODE } from './contract';

export function configuredAdminCode(): string {
  const fromEnv = import.meta.env.VITE_ADMIN_CODE;
  return typeof fromEnv === 'string' && fromEnv.trim() ? fromEnv.trim() : DEFAULT_ADMIN_CODE;
}

/** Comma-separated admin ids from VITE_ADMIN_IDS. Empty unless the host configures it. */
export function configuredAdminIds(): string[] {
  const raw = import.meta.env.VITE_ADMIN_IDS;
  if (typeof raw !== 'string') return [];
  return raw.split(',').map((id) => id.trim()).filter((id) => id.length > 0);
}

/** True when `value` is the unlock code or an id on the admin allow-list. */
export function isAdminCredential(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed === configuredAdminCode()) return true;
  return configuredAdminIds().includes(trimmed);
}
